import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetTeamTaskItemsDto, queryKeys, UrlUtilities, useAccessToken, type QueryParams } from "src/http";

const useGetTeamTaskItemsRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTeamTaskItemsRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.taskItems.getTeamTaskItems>>): Promise<GetTeamTaskItemsDto> {
    const accessToken = await getAccessToken();
    const [, teamSlug, queryParams] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/teams/${teamSlug}/task-items`);
    UrlUtilities.appendQueryParams(url, queryParams);

    const response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTeamTaskItemsRequest };
};

const useGetTeamTaskItems = (teamSlug: string | undefined, queryParams?: QueryParams) => {
  const { getTeamTaskItemsRequest } = useGetTeamTaskItemsRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getTeamTaskItems(teamSlug, queryParams),
    queryFn: getTeamTaskItemsRequest,
    enabled: teamSlug !== undefined,
  });
};

export { useGetTeamTaskItems };
